import HttpService from './HttpService';

class AuthService {
  async getCurrentUser() {
    const response = await HttpService.get('/auth/user');
    return response.data;
  }
}

export default new AuthService();
